
import { Component, Prop, Vue } from "vue-property-decorator";
import { TripStatus, TripStatusCode } from "@/components/Passenger/models/Trip";
import moment from "moment";
import { isEtaWithinThreshold } from './RouteDetails.vue';

export interface TripTimesWithStatus {
  tripId: number;
  startDateTime: Date | string;
  status: TripStatus;
}

@Component({
  components: {
  },
})
export default class RouteDetailsEta extends Vue {
  @Prop({ required: true}) trip: TripTimesWithStatus;
  @Prop({ default: false}) loading: boolean;
  @Prop({ default: 0 }) etaMinutes: number;


  /**On demand ETA update time limit in milliseconds */
  updateTimeLimit = 10_000 as const;

  /**Last time the ETA was updated */
  lastUpdatedAt = moment();

  private now = moment();
  private timer: ReturnType<typeof setInterval> | null = null;

  mounted() {
    this.timer = globalThis.setInterval(() => {
      this.now = moment();
    }, 1000);
  }

  beforeDestroy() {
    if (this.timer !== null) {
      clearInterval(this.timer);
    }
  }


  // get etaMinutes() {
  //   if (this.isFinalState) {
  //     return 0;
  //   }

  //   const plannedStartTime = moment(this.trip.startDateTime);

  //   // The status uses different terminology. Etd = Estimated Time of Departure, 
  //   // which in our case is also the estimated time of arrival (to the pickup location).
  //   const eta = moment(this.trip.status.etd);
  //   const timeDiff = eta.diff(plannedStartTime, 'minutes');

  //   return timeDiff;
  // }

  get isFinalState() {
    const finalStates = [
      TripStatusCode.Cancelled,
      TripStatusCode.NoShow,
      TripStatusCode.DropOff,
    ];

    return finalStates.includes(this.trip.status.code); 
  }

  get isUpdateAvailable() {
    return this.now.diff(this.lastUpdatedAt, 'milliseconds') > this.updateTimeLimit;
  }

  get statusText() {
    if (isEtaWithinThreshold(this.etaMinutes)) {
      return this.$t('routeDetails.eta.statusOnTime');
    }
    if (this.etaMinutes < 0) {
      return this.$t('routeDetails.eta.statusEarly', { time: Math.abs(this.etaMinutes) });
    }

    return this.$t('routeDetails.eta.statusLate', { time: this.etaMinutes });
  }

  get buttonColor() {
    if (!isEtaWithinThreshold(this.etaMinutes)) {
      return 'warning';
    }

    return 'success';
  }

  get tooltipText() {
    const limitSeconds = this.updateTimeLimit / 1000;
    const secondsFromUpdate = this.now.diff(this.lastUpdatedAt, 'seconds');
    if (secondsFromUpdate > limitSeconds) {
      return this.$t('routeDetails.eta.tooltip.updateAvailable');
    }
    return this.$t('routeDetails.eta.tooltip.secondsUntil', { seconds: limitSeconds - secondsFromUpdate });
  }

  async updateEta() {
    if (!this.isUpdateAvailable) {
      return;
    }
    
    this.$emit('update', this.trip);
    this.lastUpdatedAt = moment();
  }


}
